<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row>
      <el-col :sm="12">
        <h4 class="form-title">Repair - Damage Descriptions</h4>
      </el-col>
      <el-col :sm="12">
        <div class="d-flex justify-content-flex-end">
          <el-button type="primary" size="small" @click="openDrawer">
            Add Damage Description
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="data.data">
          <el-table-column label="Actions" width="80">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                title="Edit information"
                circle
                size="small"
                @click="edit(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column label="Name" prop="name"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-pagination
      v-show="!isLoading"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="data.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(data.paging.cur_page)"
      @current-change="fetch"
    >
    </el-pagination>
    <app-dialog
      ref="descDrawer"
      :preventClose="isLoading"
      v-loading="isLoading"
    >
      <el-form ref="form" :model="formModel" :rules="rules">
        <el-form-item label="Description" prop="desc">
          <el-input v-model="formModel.desc"></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <el-button type="primary" @click="save" :disabled="isLoading"
          >Save</el-button
        >
      </template>
    </app-dialog>
  </div>
</template>

<script>
import ULD from "@/models/ULD";
export default {
  name: "DamageDescriptions",

  data() {
    return {
      formModel: {
        id: "",
        desc: ""
      },
      rules: {
        desc: [{ required: true, message: "Damage description is required." }]
      },
      data: { paging: {}, data: [] },
      isLoading: false,
      pager: {
        limit: 100
      }
    };
  },
  methods: {
    fetch(page) {
      this.isLoading = true;
      this.pager.page = 1;
      if (page) {
        this.pager.page = page;
      }
      ULD.get_damage_descriptions(this.pager).then(list => {
        this.isLoading = false;
        if (list) this.data = list;
      });
    },
    edit(item) {
      this.$refs.descDrawer.open();
      this.$set(this.formModel, "desc", item.name);
      this.$set(this.formModel, "id", item.id);
    },
    openDrawer() {
      this.$refs.descDrawer.open();
      this.formModel = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    closeDrawer() {
      this.$refs.descDrawer.close();
    },
    save() {
      this.$confirm("Do you want to save the damage description information?")
        .then(() => {
          this.$refs.form.validate(valid => {
            if (!valid) return;
            this.isLoading = true;
            let payload = {
              name: this.formModel.desc
            };
            if (this.formModel.hasOwnProperty("id") && this.formModel.id) {
              payload.id = this.formModel.id;
              ULD.update_damage_description(payload).then(resp => {
                if (resp.code == 200) {
                  this.$notify({
                    message: "Damage description saved.",
                    position: "bottom-right",
                    type: "success"
                  });
                  this.closeDrawer();
                  this.fetch(1);
                } else {
                  this.$notify({
                    message: "Damage description not saved.",
                    position: "bottom-right",
                    type: "error"
                  });
                }
                this.isLoading = false;
              });
            } else {
              ULD.create_damage_description(payload).then(resp => {
                if (resp.code == 200) {
                  this.$notify({
                    message: "Damage description saved.",
                    position: "bottom-right",
                    type: "success"
                  });
                  this.closeDrawer();
                  this.fetch(1);
                } else {
                  this.$notify({
                    message: "Damage description not saved.",
                    position: "bottom-right",
                    type: "error"
                  });
                }
                this.isLoading = false;
              });
            }
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style lang="css" scoped></style>
